import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Switch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: this.props.active,
		};
	}
	toggleSwitch = () => {
		this.setState({ active: !this.props.active });
		this.props.onClick();
	};
	componentWillReceiveProps(newProps) {
		if (newProps.active === undefined) return;
		if (this.state.active !== newProps.active) {
			this.setState({ active: newProps.active });
		}
	}
	render() {
		return (
			<div
				className={this.state.active ? 'switch on' : 'switch'}
				onClick={this.toggleSwitch.bind(this)}
			>
				<div className="handle" />
			</div>
		);
	}
}

// PropTypes
Switch.propTypes = {
	active: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
};

export default Switch;
